import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getPaginatedActivities } from "../../services/Analytics";

export const fetchActivities = createAsyncThunk(
  "analytics/fetchActivities",
  async (params, { rejectWithValue }) => {
    try {
      const response = await getPaginatedActivities(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const activitiesSlice = createSlice({
  name: "activities",
  initialState: {
    items: [],
    pagination: { total: 0, page: 1, limit: 10, totalPages: 1 },
    loading: false,
    error: null,
    filters: {
      search: "",
      sortBy: "createdAt",
      order: "desc",
      type: "",
    },
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActivities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchActivities.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchActivities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setFilters } = activitiesSlice.actions;
export default activitiesSlice.reducer;
